import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import PAGE_TYPES from 'tradera-constants/page-types';
import * as gtm from 'tradera-apps/tradera/components/discover/helpers/search-gtm';
import {
    stripPaginationFromQueryParameters,
    toSearchString
} from 'tradera-utils/url';

const FilterCategoriesHorizontal = ({
    filterCategories,
    handleCategoryChange,
    handleSearchCategoryChange,
    pageType,
    queryParams
}) => {
    const categoryContainerRef = useRef(null);
    useEffect(() => {
        if (categoryContainerRef.current)
            categoryContainerRef.current.scrollLeft = 0;
    }, [filterCategories]);

    if (!filterCategories || !filterCategories.categoryTree) {
        return null;
    }

    const { categoryTree, activeCategory } = filterCategories;
    const categoryResultPage = pageType === PAGE_TYPES.CATEGORY_RESULT_PAGE;

    const trackCategoryClick = (category, path) => {
        let strPath = [...path, category.name].join(' > ');
        gtm.trackFilter('categoryHorizontalSelected', strPath);
    };

    const Category = ({ categories, path, topCategory = true }) =>
        categories && categories.length > 0
            ? [...categories]
                  .sort((a, b) => {
                      if (a.name > b.name) {
                          return 1;
                      } else if (a.name < b.name) {
                          return -1;
                      } else {
                          return 0;
                      }
                  })
                  .map(category => (
                      <div className="d-flex" key={category.id}>
                          {categoryResultPage ? (
                              <Link
                                  to={{
                                      pathname: category.url,
                                      search: toSearchString(
                                          stripPaginationFromQueryParameters(
                                              queryParams
                                          )
                                      )
                                  }}
                                  onClick={e => {
                                      trackCategoryClick(category, path);
                                      handleCategoryChange(category, e);
                                  }}
                                  className={`btn btn-tag btn-outline-dark text-nowrap mx-1 px-2 ${topCategory &&
                                      'active'}`}>
                                  {category.name}
                              </Link>
                          ) : (
                              <button
                                  onClick={() => {
                                      trackCategoryClick(category, path);
                                      handleSearchCategoryChange(category);
                                  }}
                                  className={`btn btn-tag btn-outline-dark text-nowrap mr-1 px-1 ${topCategory &&
                                      'active'}`}>
                                  {category.name}
                              </button>
                          )}
                          {category.children && (
                              <Category // calls self
                                  categories={category.children}
                                  className="ml-3"
                                  path={[...path, category.name]}
                                  topCategory={false}
                              />
                          )}
                      </div>
                  ))
            : null;

    return (
        <div
            ref={categoryContainerRef}
            className="d-flex overflow-x-auto hide-scrollbar pr-1 pr-md-2">
            <Category categories={[activeCategory || categoryTree]} path={[]} />
        </div>
    );
};

export default React.memo(FilterCategoriesHorizontal);

FilterCategoriesHorizontal.propTypes = {
    filterCategories: PropTypes.shape({
        categoryTree: PropTypes.object,
        parameter: PropTypes.string,
        type: PropTypes.string
    }).isRequired,
    handleCategoryChange: PropTypes.func,
    handleSearchCategoryChange: PropTypes.func,
    pageType: PropTypes.string.isRequired,
    queryParams: PropTypes.object.isRequired
};
